<template>
  <div id="vipOpenContent">
    <div class="app-msg">
      <div>
        <span class="app-msg-title">开通VIP，使用专享伪装APP</span>
      </div>
      <div class="app-ba">
        <img src="../../assets/img/center-lo-1@2x.png" alt />
        <div class="app-ba-content">伪装升级、功能强大，360°保护您的隐私</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "vipOpenContent",
  data() {
    return {
      msg: "vipOpenContent"
    };
  },
 
};
</script>
<style  scoped>
.app-msg {
  height: 100px;
  text-align: center;
  margin: 36px auto 44px auto;
}
.app-msg-title {
  width: 288px;
  height: 66px;
  font-size: 48px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(245, 195, 167, 1);
  line-height: 66px;
  background: linear-gradient(
    148deg,
    rgba(233, 205, 181, 1) 0%,
    rgba(214, 170, 150, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.app-ba {
  width: 670px;
  height: 200px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 0 auto;
}

.app-ba img {
  width: 100%;
  height: 10px;
}

.app-ba-content {
  position: relative;
  top: -35px;
}

</style>


// WEBPACK FOOTER //
// src/components/common/vipOpenContent.vue